<template>
  <section class="slide-horizontal">
    <h1 class="title">Desbrave novas estratégias</h1>
    <h2 class="subtitle">Através de resultados concisos, totalmente baseados em porcentagens, os resultados do TD Score servem como um guia para pautar novas estratégias necessárias para as mudanças de sua empresa. <br> Além da maturidade digital total, ele ainda oferece indicadores individuais e minuciosos para cada uma das dimensões compreendidas.</h2>
    <div class="slide-area">
      <a href="#" @click.prevent="prevItem()" class="nav-arrow nav-left">
        <icon name="arrow-right" half></icon>
      </a>
      <div class="slide-wrap">
        <transition :name="slideTransition" mode="out-in">
          <div class="slide-item" key="1" v-if="current == 1">
            <a href="#" @click.prevent="showItem(videos.VideoForm)" class="slide-media">
              <video height="100%" autoplay loop :src="videos.VideoForm"></video>
            </a>
            <a href="#" @click.prevent="showItem(videos.VideoResult)" class="slide-media">
              <video height="100%" autoplay loop :src="videos.VideoResult"></video>
            </a>
            <a href="#" @click.prevent="showItem(videos.VideoDigital)" class="slide-media">
              <video height="100%" autoplay loop :src="videos.VideoDigital"></video>
            </a>
          </div>
          <div class="slide-item" key="2" v-if="current == 2">
            <a href="#" @click.prevent="showItem(videos.VideoMoreResult)" class="slide-media">
              <video height="100%" autoplay loop :src="videos.VideoMoreResult"></video>
            </a>
            <a href="#" @click.prevent="showItem(videos.VideoProgress)" class="slide-media">
              <video height="100%" autoplay loop :src="videos.VideoProgress"></video>
            </a>
          </div>
        </transition>
      </div>
      <a href="#" @click.prevent="nextItem()" class="nav-arrow nav-right">
        <icon name="arrow-right" half></icon>
      </a>
      <div class="nav-lines">
        <a href="#" class="line" @click.prevent="setItem(1)">
          <div class="block" :class="{ active: current == 1}"></div>
        </a>
        <a href="#" class="line" @click.prevent="setItem(2)">
          <div class="block" :class="{ active: current == 2}"></div>
        </a>
      </div>
    </div>
    <modal-media :src="modalVideo" @close="closeModal" />
  </section>
</template>

<script>
import Icon from './Icon';
import ModalMedia from './ModalMedia';

import VideoForm from './../assets/video/form.mp4';
import VideoProgress from './../assets/video/progress.mp4';
import VideoResult from './../assets/video/result.mp4';
import VideoDigital from './../assets/video/youaredigital.mp4';
import VideoMoreResult from './../assets/video/moreresult.mp4';

export default {
  name: 'slide-horizontal',
  components: { Icon, ModalMedia },
  data() {
    return {
      slideTransition: 'slide',
      totalItens: 2,
      current: 1,
      videos: {
        VideoForm,
        VideoProgress,
        VideoResult,
        VideoDigital,
        VideoMoreResult,
      },
      modalVideo: '',
    };
  },
  methods: {
    showItem(media) {
      this.modalVideo = media;
    },
    closeModal() {
      this.modalVideo = '';
    },
    nextItem() {
      if (this.current < this.totalItens) {
        this.slideTransition = 'slide';
        this.current += 1;
      }
    },
    prevItem() {
      if (this.current > 1) {
        this.slideTransition = 'slide-left';
        this.current -= 1;
      }
    },
    setItem(index) {
      if (index < this.current) {
        this.slideTransition = 'slide-left';
      } else {
        this.slideTransition = 'slide';
      }
      this.current = index;
    },
  },
};
</script>

<style lang="scss" scoped>
  $color-title: #121416;
  $slide-item-width: 193px;
  $slide-item-margin: 15px;

  .slide-horizontal {
    padding: 120px 0;
    background: grey;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(./../assets/img/bg-dark-noises.jpg) center center;
    background-size: cover;
    color: white;
    .title {
      text-transform: uppercase;
      letter-spacing: 10px;
      text-indent: 10px;
      margin: 0 0 42px 0;
    }
    .subtitle {
      font-size: 20px;
      line-height: 150%;
      width: 70%;
      margin: 0 0 62px 0;
      @media (max-width: 576px) {
        width: auto;
        padding: 0 26px;
      }
    }
    .slide-area {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      @media (max-width: 576px) {
        width: 100%;
      }
    }
    .slide-wrap {
      position: relative;
      display: flex;
      align-items: center;
      overflow: hidden;
      width: ($slide-item-width + $slide-item-margin * 2) * 3;
      height: $slide-item-width;
      @media (max-width: 576px) {
        height: ($slide-item-width + $slide-item-margin * 2) * 3;
        width: $slide-item-width;
      }
    }
    .slide-item {
      display: flex;
      justify-content: center;
      width: 100%;
      @media (max-width: 576px) {
        flex-direction: column;
      }
      .slide-media {
        margin: 0 $slide-item-margin;
        background-color: #d7d7d7;
        width: $slide-item-width;
        height: $slide-item-width;
        overflow: hidden;
        display: flex;
        justify-content: center;
        @media (max-width: 576px) {
          margin: $slide-item-margin 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SlideHorizontal.vue